module.exports = __webpack_public_path__ + "static/img/redBell.607f10ca.png";